import { setApiError, setGenericError } from "../store/reducers/errorSlice";
import { store } from "../store/store";
import {
  Error,
  ErrorType,
  InvalidSessionErrorsCodes,
  SilentBusinessErrorCodes,
  errorType,
} from "../types/error.definition";

export const isValidErrorFormat = (error: Error) =>
  typeof error === "object" &&
  "code" in error &&
  typeof error.code === "string";

export const isSilentError = (error: Error) => {
  return (
    InvalidSessionErrorsCodes.includes(error.code) ||
    SilentBusinessErrorCodes.includes(error.code)
  );
};

export const errorCategoryMapper = (error: Error) => {
  const tmpError: Error = { ...error };
  let category: ErrorType = errorType.RETRIABLE_UNEXPECTED_ERROR;

  if (InvalidSessionErrorsCodes.includes(error.code)) {
    category = errorType.NO_RETRIABLE_UNEXPECTED_ERROR;
  } else {
    category = errorType.RETRIABLE_UNEXPECTED_ERROR;
  }
  return { ...tmpError, category };
};

export const dispatchError = (error: Error, isGenericError: boolean) => {
  if (isGenericError || error.code === "UNEXPECTED_ERROR") {
    store.dispatch(setGenericError(error.message || ""));
  } else {
    store.dispatch(setApiError(error));
  }
};
